import { render, staticRenderFns } from "./GdTabs.vue?vue&type=template&id=a119177e"
import script from "./GdTabs.vue?vue&type=script&lang=js"
export * from "./GdTabs.vue?vue&type=script&lang=js"
import style0 from "./GdTabs.vue?vue&type=style&index=0&id=a119177e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports